export function getQueryStringParams(): Record<string, string | null> {
  const searchParams = new URLSearchParams(location.search);

  const params: Record<string, string | null> = {};
  for (const param of searchParams) {
    params[param[0]] = param[1];
  }
  return params;
}
